/* ORION: the description of the refreshed mattress page (snippets/orion-mattress-story.liquid). "Περισσότερα" unfolds
   the longer description and "Λιγότερα" folds it again. Once the block has left the screen, up or down, it folds by
   itself as soon as the scrolling comes to rest, so it is closed when the visitor comes back to it. When it folds above
   the screen, the page moves by exactly what it lost, so what the visitor is looking at does not jump. Folded, the
   longer text is hidden until found: a search in the page reaches it and opens it. By the owner's rule the parts rise
   also when the system asks for reduced motion.
   An easter egg: the boards of a bed base are called both τάβλες and λάτες. In the longer text either word turns into
   the other when pressed, and a search for either one finds it (the other name waits in the page, hidden until found,
   and shows itself when a search reaches it). */
(() => {
  const CALM = 160; // ms without scrolling before a block that is off screen folds
  const FOLD = 750; // the length of the fold, as in assets/orion-mattress-refresh.css
  const NAMES = { 'τάβλες': 'λάτες', 'λάτες': 'τάβλες' };
  const NAME_PATTERN = /(τάβλες|λάτες)/;
  const HINT = { 'τάβλες': 'Λέγονται και λάτες', 'λάτες': 'Λέγονται και τάβλες' };

  // One word that answers a press with its other name; the name not shown stays in the page, hidden until found.
  function nameWord(written) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'orion-word';
    const names = [written, NAMES[written]].map((name, index) => {
      const span = document.createElement('span');
      span.className = 'orion-word__name';
      span.textContent = name;
      if (index) span.setAttribute('hidden', 'until-found');
      return span;
    });
    button.append(...names);
    button.title = HINT[written];
    const show = (span, animate) => {
      const other = names.find((name) => name !== span);
      span.removeAttribute('hidden');
      other.setAttribute('hidden', 'until-found');
      button.title = HINT[span.textContent];
      if (animate && span.animate) {
        span.animate(
          [{ opacity: 0, transform: 'translateY(45%)' }, { opacity: 1, transform: 'translateY(0)' }],
          { duration: 420, easing: 'cubic-bezier(.22,.61,.36,1)' },
        );
      }
    };
    button.addEventListener('click', () => show(names.find((name) => name.hasAttribute('hidden')), true));
    names.forEach((span) => span.addEventListener('beforematch', () => show(span, false)));
    return button;
  }

  function nameWords(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const found = [];
    while (walker.nextNode()) if (NAME_PATTERN.test(walker.currentNode.nodeValue)) found.push(walker.currentNode);
    found.forEach((node) => {
      const fragment = document.createDocumentFragment();
      node.nodeValue.split(NAME_PATTERN).forEach((part) => {
        if (NAMES[part]) fragment.append(nameWord(part));
        else if (part) fragment.append(part);
      });
      node.replaceWith(fragment);
    });
  }

  function setup(story) {
    const toggle = story.querySelector('[data-orion-story-toggle]');
    const more = story.querySelector('[data-orion-story-more]');
    const inner = more?.querySelector('.orion-story__more-inner');
    const label = story.querySelector('[data-orion-story-label]');
    if (!toggle || !more || !inner) return;
    // Each part of the longer text rises in its turn.
    const text = more.querySelector('.metafield-rich_text_field') || inner.firstElementChild;
    if (text) {
      [...text.children].forEach((part, index) => part.style.setProperty('--i', index));
      nameWords(text);
    }

    let away = false;
    let timer = 0;
    let hideTimer = 0;
    const isOpen = () => story.classList.contains('is-open');
    const calm = () => {
      clearTimeout(timer);
      timer = setTimeout(fold, CALM);
    };
    const arm = () => {
      window.addEventListener('scroll', calm, { passive: true });
      calm();
    };
    const disarm = () => {
      clearTimeout(timer);
      window.removeEventListener('scroll', calm);
    };
    const set = (open, instant = false) => {
      clearTimeout(hideTimer);
      if (open) inner.removeAttribute('hidden');
      story.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', String(open));
      // The words come from the page, in its language (data-more, data-less on the button).
      if (label) label.textContent = open ? (toggle.dataset.less || 'Λιγότερα') : (toggle.dataset.more || 'Περισσότερα');
      if (!open) {
        disarm();
        // Folded, the text is hidden until found (after the fold has played).
        if (instant) inner.setAttribute('hidden', 'until-found');
        else hideTimer = setTimeout(() => { if (!isOpen()) inner.setAttribute('hidden', 'until-found'); }, FOLD);
      }
    };
    const instantly = (change) => {
      story.classList.add('is-instant');
      change();
      requestAnimationFrame(() => requestAnimationFrame(() => story.classList.remove('is-instant')));
    };
    // Off screen the block folds at once; above the screen the page follows it, so nothing on screen moves.
    function fold() {
      if (!away || !isOpen()) return;
      const before = story.getBoundingClientRect();
      instantly(() => set(false, true));
      const after = story.getBoundingClientRect();
      if (before.bottom <= 0 && after.bottom !== before.bottom) {
        window.scrollBy({ top: after.bottom - before.bottom, behavior: 'instant' });
      }
    }

    toggle.addEventListener('click', () => set(!isOpen()));
    // A search in the page reached the folded text: it opens at once, so the browser scrolls to the final place.
    inner.addEventListener('beforematch', () => instantly(() => set(true)));
    new IntersectionObserver((entries) => {
      away = !entries[entries.length - 1].isIntersecting;
      if (away && isOpen()) arm();
      else disarm();
    }).observe(story);
  }

  document.querySelectorAll('[data-orion-story]').forEach((story) => {
    if (story.orionStory) return;
    story.orionStory = true;
    setup(story);
  });
})();
